import React, { useEffect, useState } from 'react';
import { useParams, Rounter, Routes, Route, Switch, Link, Outlet } from "react-router-dom";
import axios from 'axios';

const ShowPost = (props) => {
    const { listPost } = props;
    return (
        <div className="post">
            {listPost.map((post, index) => {
                return (
                    <React.Fragment key={post.id}>
                        <div className="post">
                            <h2 className="post_title">{post.title.rendered}</h2>
                            <div className="post_content" dangerouslySetInnerHTML={{ __html: post.content.rendered }} />
                        </div>
                    </React.Fragment>
                );
            })}
        </div>
    );
};

function Home(props) {
    let { Id } = useParams();
    const [listPost, setListPost] = useState([]);
    const [isLoading, setLoading] = useState(true);

    const getPost = () => {
        setLoading(true);
        axios
            .get(`http://hoanlam.webstarterz.com/hoanlam.webstarterz.com/wp-json/wp/v2/posts`)
            .then((res) => {
                setListPost(res.data);
            })
            .catch((err) => {
                alert("Không thể kết nối server");
            })
            .finally(() => {
                setLoading(false);
            });
    };
    useEffect(() => {
        getPost();
    }, [Id])


    return (
        <div className="postcate">
            <div className="container">
                {isLoading ? "loading..." : <ShowPost listPost={listPost} />}
            </div>
        </div>
    );
}

export default Home